Vue.asyncComponent('bp-tabs', {
}, 'blueprints/utils/tabs/bp-tabs.html');